import React from "react";
import { View, Text, Button } from "react-native";
export default ({ navigation }) => (<View style={{ flex: 1, alignItems: "center", justifyContent: "center" }}>
    <Text style={{ fontSize: 30 }}>First steps</Text>
    <Button onPress={() => navigation.navigate("StackNavigator")} title="Dismiss"/>
  </View>);
